import AppsIcon from '@atlaskit/icon/core/apps';
import {
  ExpandableMenuItem,
  ExpandableMenuItemContent,
  ExpandableMenuItemTrigger,
} from '@atlaskit/navigation-system/side-nav-items/expandable-menu-item';
import { LinkMenuItem } from '@atlaskit/navigation-system/side-nav-items/link-menu-item';

import { MenuItem } from 'src/components/navigation/src/types';
import { useLocation } from 'src/router/hooks';
import { settings } from 'src/settings';

import { getIconForMenuItem, getLinkItemAfterContent } from './icons';
import { isMenuItemSelected } from './utils';

type AppFolderProps = {
  appItems: MenuItem[];
};

export const getAppMenuItems = (appItems: MenuItem[], pathname: string) => {
  let isSelected = false;
  const components: React.ReactElement[] = [];
  appItems.forEach(menuItem => {
    const isItemSelected = isMenuItemSelected(menuItem, pathname);
    isSelected = isSelected || isItemSelected;

    components.push(
      <LinkMenuItem
        key={menuItem.id}
        // Due to COREX-12399, we're using an absolute URL to force a non-SPA navigation
        // when pages are not yet supported in Frontbucket (neither fully nor via iframe)
        href={
          menuItem.is_client_link
            ? menuItem.url
            : new URL(menuItem.url, settings().CANON_URL).toString()
        }
        elemBefore={getIconForMenuItem(menuItem)}
        elemAfter={getLinkItemAfterContent(menuItem)}
        isSelected={isItemSelected}
      >
        {menuItem.label}
      </LinkMenuItem>
    );
  });

  return { components, isSelected };
};

export const ExpandableAppFolder = ({ appItems }: AppFolderProps) => {
  const { pathname } = useLocation();
  if (appItems.length === 0) {
    return null;
  }

  const { components, isSelected } = getAppMenuItems(appItems, pathname);

  return (
    <ExpandableMenuItem isDefaultExpanded={isSelected}>
      <ExpandableMenuItemTrigger elemBefore={<AppsIcon label="" />}>
        Apps
      </ExpandableMenuItemTrigger>
      <ExpandableMenuItemContent>{components}</ExpandableMenuItemContent>
    </ExpandableMenuItem>
  );
};
